import {MenuItem, useTheme} from "@mui/material";
import React, {useState} from "react";
import {DeleteDialog} from "../dialogs/DeleteDialog";
import {useTranslation} from "react-i18next";

export function DeleteWithConfirmMenuEntry(props: {
  onDelete: () => void,
  title?: string,
  disabled?: boolean,
}) {
  const theme = useTheme();
  const {t} = useTranslation();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    (<div>
      <MenuItem disabled={props.disabled} onClick={() => setDeleteDialogOpen(true)}
                sx={{color: theme.palette.error.main,}}>{t('buttons.delete')}</MenuItem>
      <DeleteDialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} onConfirm={props.onDelete} itemName={props.title}/>
    </div>)
  );
}
